(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lume-buy-more"] && !Shopify.designMode) return;
  try {
    (function () {
    function fmtFooter(n, pct) {
      return 'Add ' + n + ' more item' + (n === 1 ? '' : 's') + ' for ' + pct + '% off';
    }
    function apply(root, count) {
      var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-lume-bm-tier]'));
      var footer = root.querySelector('[data-lume-bm-footer]');
      var next = null;
      tiers.forEach(function (t) {
        var q = parseInt(t.getAttribute('data-qty'), 10) || 0;
        t.classList.remove('is-reached', 'is-next');
        if (count >= q) t.classList.add('is-reached');
        else if (!next) { next = t; t.classList.add('is-next'); }
      });
      if (count > 0) {
        root.classList.add('is-dynamic');
        if (footer) footer.textContent = next ? fmtFooter(parseInt(next.getAttribute('data-qty'), 10) - count, next.getAttribute('data-pct')) : 'Maximum discount unlocked';
      } else {
        root.classList.remove('is-dynamic');
        if (footer) footer.textContent = footer.getAttribute('data-default');
      }
    }
    function refresh() {
      var roots = document.querySelectorAll('[data-lume-bm][data-lume-bm-dynamic="true"]');
      if (!roots.length) return;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        roots.forEach(function (el) { apply(el, c.item_count || 0); });
      }).catch(function () {});
    }
    var t = null;
    function schedule() { clearTimeout(t); t = setTimeout(refresh, 600); }
    refresh();
    document.addEventListener('cart:update', schedule);
    document.addEventListener('cart-lines:update', schedule);
    if (typeof window.upcartOnCartUpdated === 'function') { try { window.upcartOnCartUpdated(schedule); } catch (e) {} }
    if (typeof window.upcartOnAddToCart === 'function') { try { window.upcartOnAddToCart(schedule); } catch (e) {} }
    // Fallback: any cart request finished → refresh
    var of = window.fetch;
    window.fetch = function (u) { var p = of.apply(this, arguments); if (String(u).indexOf('/cart/') >= 0) p.then(schedule, function () {}); return p; };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lume-test-js"] && !Shopify.designMode) return;
  try {
    console.log('x');
  } catch(e) { console.error(e); }
})();

})();
